<template>
  <div class="iframe-container">
    <iframe
      :src="'https://dpd.talentprint.com/users/manage_raters/'+autoLoginToken"
      class="w-full h-full border-0"
    >
    </iframe>
  </div>
</template>

<script>
  export default {
    name: "Main",
    created() {
      this.$store.commit("SET_PAGE_TYPE", "alex-connect");
      this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
    },
    computed: {
      autoLoginToken() {
        return this.$store.state.alex.data.youlabToken;
      },
    }
  };
</script>
<style scoped>
  .iframe-container {
    height: 1005px;
    margin-top: 6rem;
  }
</style>
